/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import GroupDetailHOC from 'ui-permit/shared-components/registration/GroupDetailNew';

const GroupDetail = GroupDetailHOC(undefined, {
    GROUP_DETAIL_PROP_PATH: 'primary_permit_holder',
    GROUP_DETAIL_ADDRESS_PROP_PATH: 'primary_permit_holder.home_address',
    GROUP_DETAIL_ADDRESS1_PROP_PATH: 'street[0]',
    GROUP_DETAIL_ADDRESS2_PROP_PATH: 'street[1]',
    GROUP_DETAIL_COUNTRY_PROP_PATH: 'country_code',
});

function GroupDetailNew(props) {
    return (
        <div className="rec-grid-12-12">
            <GroupDetail {...props} />
        </div>
    );
}

export default GroupDetailNew;
